import { createSelector } from "@reduxjs/toolkit";

export const selectBreadcrumbState = createSelector(
  (state) => state.patient,
  (state) => state.customer,
  (state) => state.user,
  (state) => state.layouts,
  (state) => state.forms,
  (patient, customer, user, layouts, forms) => ({
    patient,
    customer,
    user,
    layouts,
    forms,
  })
);
